export const wednesdayAbbreviatedLowercase = "Hqa";
export default {wednesdayAbbreviatedLowercase};